import styles from '../Disco.module.css';

interface CounterProps {
  current: number;
  total: number;
}

export function Counter({ current, total }: CounterProps) {
  return (
    <div className={styles.counter}>
      {current} of {total}
    </div>
  );
}
